<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre3" id="calibre_pb_0"></div><div class="footnote">
<h2 class="chapterhead">Contents</h2>
<div class="footnote">
<p class="ToC">
<span href="#/cover_split_000" title="Link target outside of Sample">Cover</span>
</p>
<div class="footnote">
<p class="ToC1">
<span href="#/cover_split_001#credits" title="Link target outside of Sample">Imprint</span>
</p>
</div>
<div class="footnote">
<p class="ToC1">
<span href="#/cover_split_002#epigraph" title="Link target outside of Sample">Epigraph</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<a href="#/chapter1">INTRODUCTION</a>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<a href="#/chapter2">TRACK ONE</a>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter3" title="Link target outside of Sample">TRACK TWO</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter4" title="Link target outside of Sample">TRACK THREE</span>
</p>
</div>
<div class="footnote">
<p class="ToC1">
<span href="#/chapter4#section0.4.1" title="Link target outside of Sample">  Great New Orleans Voodoo Kings and Queens</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter5" title="Link target outside of Sample">TRACK FOUR</span>
</p>
</div>
<div class="footnote">
<p class="ToC1">
<span href="#/chapter5#section0.5.1" title="Link target outside of Sample">  Hummingbird Cake</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter6" title="Link target outside of Sample">TRACK FIVE</span>
</p>
</div>
<div class="footnote">
<p class="ToC1">
<span href="#/chapter6#section0.6.1" title="Link target outside of Sample">  Jambalaya</span>
</p>
</div>
<div class="footnote">
<p class="ToC1">
<span href="#/chapter6#section0.6.2" title="Link target outside of Sample">  Crawfish Pie</span>
</p>
</div>
<div class="footnote">
<p class="ToC1">
<span href="#/chapter6#section0.6.3" title="Link target outside of Sample">  Filé Gumbo</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter7" title="Link target outside of Sample">TRACK SIX</span>
</p>
</div>
<div class="footnote">
<p class="ToC1">
<span href="#/chapter7#section0.7.1" title="Link target outside of Sample">  The Ten Activities Most Likely to Precipitate an Alligator Attack</span>
</p>
</div>
<div class="footnote">
<p class="ToC1">
<span href="#/chapter7#section0.7.2" title="Link target outside of Sample">  Eating with Amos — Alligator Recipes</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter8" title="Link target outside of Sample">TRACK SEVEN</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter9" title="Link target outside of Sample">TRACK EIGHT</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter10" title="Link target outside of Sample">TRACK NINE</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter11" title="Link target outside of Sample">TRACK TEN</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter12" title="Link target outside of Sample">TRACK ELEVEN</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter13" title="Link target outside of Sample">TRACK TWELVE</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter14" title="Link target outside of Sample">TRACK THIRTEEN</span>
</p>
</div>
<div class="footnote">
<p class="ToC1">
<span href="#/chapter14#section0.14.1" title="Link target outside of Sample">  The Queens of Storyville — 10 Notorious New Orleans Madams</span>
</p>
</div>
<div class="footnote">
<p class="ToC1">
<span href="#/chapter14#section0.14.2" title="Link target outside of Sample">  New Orleans — The Cost of Living, Circa 1800</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter15" title="Link target outside of Sample">TRACK FOURTEEN</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter16" title="Link target outside of Sample">TRACK FIFTEEN</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter17" title="Link target outside of Sample">TRACK SIXTEEN</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter18" title="Link target outside of Sample">TRACK SEVENTEEN</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter19" title="Link target outside of Sample">TRACK EIGHTEEN</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter20" title="Link target outside of Sample">EPILOGUE</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter21" title="Link target outside of Sample">BIBLIOGRAPHY</span>
</p>
</div>
</div>
<div class="footnote">
<div class="footnote">
<p class="ToC">
<span href="#/chapter22" title="Link target outside of Sample">ACKNOWLEDGMENTS</span>
</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?df6c3d12